import { useEffect } from "react";

import { useAppContext } from "../context/AppContext";
import useAxios from "../utils/useAxios";

const useFetchMasterData = () => {
  const { dispatch } = useAppContext();


  const axiosAPI = useAxios()

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: "SET_LOADING", payload: true });
      try {
        const res = await axiosAPI.get("/api/donor/get-donor-details"); 
        // console.log("res",res.data.data)
        dispatch({ type: "SET_DATA", payload: res.data.data });
      } catch (error) {
        console.error("Error fetching master data:", error);
      } finally {
        dispatch({ type: "SET_LOADING", payload: false });
      }
    };

    fetchData();
  }, []);
};

export default useFetchMasterData;
